import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

/**
 * Shared button styles (primary, outline, link, danger) with optional flex row layout.
 * Use `to` for react-router Link, `href` for anchor, otherwise renders `button` or `as`.
 */
function Button({
    as,
    children,
    className = '',
    variant = 'primary',
    flex = false,
    to,
    href,
    type = 'button',
    disabled,
    ...rest
}) {
    const classes = [
        'button',
        flex && 'button--flex',
        variant === 'outline' && 'button--outline',
        variant === 'link' && 'button--link',
        variant === 'danger' && 'button--danger',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    if (to) {
        return (
            <Link to={to} className={classes} {...rest}>
                {children}
            </Link>
        );
    }

    if (href) {
        return (
            <a href={href} className={classes} {...rest}>
                {children}
            </a>
        );
    }

    const Component = as || 'button';
    const isNativeButton = Component === 'button';

    return (
        <Component
            type={isNativeButton ? type : undefined}
            className={classes}
            disabled={isNativeButton ? disabled : undefined}
            {...rest}
        >
            {children}
        </Component>
    );
}

export default Button;
